import { Fragment } from 'react';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import ImagesComponent from './ImagesComponent';
import classes from './ShortlistTable.module.css';

import dragHandle from '../../assets/img/dragIcon.svg';
import useAddShortlistedoption from '../../store/contexts/useAddShortlistedoption';
import { reorderShortListData } from '../../utils/utils';

const AmenitiesTable = ({ shortlist }) => {
  const { putOption, inProgress } = useAddShortlistedoption();
  const dispatch = useDispatch();

  let shortListCopy = reorderShortListData(shortlist);

  const dragendHandler = (params) => {
    if (!params.destination || params.destination.index === params.source.index) return;
    const srcI = params.source.index;
    const desI = params.destination.index;

    shortListCopy.splice(desI, 0, shortListCopy.splice(srcI, 1)[0]);

    shortListCopy = shortListCopy.map((obj, index) => ({
      ...obj,
      shortlistedOrder: index + 1,
    }));

    const ids = shortListCopy.map((item) => item.optionId);

    putOption(
      () => {
        dispatch({
          type: 'SET_SHORTLIST_IDS',
          ids: ids,
        });
      },
      'RESET',
      ids,
      shortListCopy,
    );
  };

  return (
    <Fragment>
      <thead>
        <tr>
          <th style={{ minWidth: '40px' }}>
            <img src={dragHandle} alt=".." />
          </th>
          <th style={{ minWidth: '250px' }}>Photos</th>
          <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Name</th>
          <th style={{ minWidth: '250px' }}>Amenities</th>
        </tr>
      </thead>
      {typeof shortListCopy === 'undefined' && (
        <tbody>
          <tr>
            <td colSpan="8" style={{ textAlign: 'center' }}>
              Nothing is shortlisted
            </td>
          </tr>
        </tbody>
      )}
      <DragDropContext onDragEnd={dragendHandler}>
        <Droppable droppableId="droppale-3">
          {(provided, _) => (
            <tbody ref={provided.innerRef} {...provided.droppableProps}>
              {shortListCopy &&
                shortListCopy.map((item, idx) => (
                  <Draggable key={item.id} draggableId={'draggable3-' + item.id} index={idx}>
                    {(provided, snapshot) => (
                      <tr
                        key={'amenities' + item.id}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={snapshot.isDragging ? classes.snapshot : ''}
                      >
                        <td
                          style={{ width: '40px', height: '130px' }}
                          {...provided.dragHandleProps}
                        >
                          <img src={dragHandle} alt=".." />
                        </td>
                        <td style={{ width: '250px', height: '120px' }}>
                          <ImagesComponent images={item.images} width="200px" height="110px" />
                        </td>
                        <td style={{ width: '150px', height: '130px' }}>{item.optionName}</td>
                        <td style={{ minWidth: '250px' }}>
                          {item?.amenities && item?.amenities.map((head) => `${head}`).join(', ')}
                        </td>
                      </tr>
                    )}
                  </Draggable>
                ))}
            </tbody>
          )}
        </Droppable>
      </DragDropContext>
      {inProgress && (
        <span className={classes.spinner}>
          <CircularProgress color="inherit" />
        </span>
      )}
    </Fragment>
  );
};

export default AmenitiesTable;
